import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { Contract } from '@/features/contratos/pages/contract'
import { ContractRenovation } from '@/features/contratos/pages/contract-renovation'

export default function Component() {
  return (
    <Routes>
      {/* <Route index element={<Pages.Contracts />} /> */}
      <Route path="novo" element={<Contract.Create />} />
      <Route path=":contract_id" element={<Outlet />}>
        <Route index element={<Contract.Dashboard />} />
        <Route path="editar" element={<Contract.Edit />} />
        <Route path="renovacoes/novo" element={<ContractRenovation.Create />} />
        <Route
          path="renovacoes/:renovation_id"
          element={<ContractRenovation.Edit />}
        />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
